import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@chakra-ui/react";
import ConfirmDangerModal from "./ConfirmDangerModal";

const ConfirmDangerButton = ({
  confirmTitle,
  confirmMessage,
  confirmButtonText,
  onConfirm,
  onClick,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    onClick?.();
  }, [setIsOpen, onClick]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    onConfirm?.();
  }, [setIsOpen, onConfirm]);

  return (
    <>
      <Box {...rest} onClick={handleOpen} />
      <ConfirmDangerModal
        confirmTitle={confirmTitle}
        confirmMessage={confirmMessage}
        confirmButtonText={confirmButtonText}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isOpen={isOpen}
      />
    </>
  );
};

ConfirmDangerButton.propTypes = {
  confirmTitle: PropTypes.string,
  confirmMessage: PropTypes.string,
  confirmButtonText: PropTypes.string,
  onConfirm: PropTypes.func,
  onClick: PropTypes.func,
};

ConfirmDangerButton.defaultProps = {
  confirmTitle: undefined,
  confirmMessage: undefined,
  confirmButtonText: undefined,
  onConfirm: undefined,
  onClick: undefined,
};

export default ConfirmDangerButton;
